module.exports = __webpack_public_path__ + "static/media/storefront.80327384.jpg";